import React from 'react';
import Roles from 'constants/UserRoles';
import DataList from 'components/ui/DataList';
import DataPoller from 'components/ui/DataPoller';
import LocationActionCreators from 'actions/LocationActionCreators';
import LocationSearch from 'components/site/location-search';
import LocationStore from 'stores/LocationStore';
import ConfirmModal from 'components/ui/modals/ConfirmModal';
import _ from 'underscore';
import SessionStore from 'stores/SessionStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import Mapping from './Mapping';
import CreateLocationModal from './CreateLocationModal';
const CAN_CREATE_LOCATIONS = [
    Roles.LOCATIONS_MANAGER,
    Roles.LOCATIONS_ADMIN,
    Roles.GOD,
];
const deleteRoles = [Roles.LOCATIONS_MANAGER, Roles.LOCATIONS_ADMIN, Roles.GOD];
function mapRoles() {
    const roles = SessionStore.getUserRoles();
    const canDelete = roles.some((r) => deleteRoles.includes(r));
    return {
        canDelete,
    };
}
class List extends React.Component {
    constructor(props) {
        super(props);
        this.handleLocationStoreChange = () => {
            const locationList = LocationStore.getLocationList() || {};
            const locations = locationList.items || [];
            const location = LocationStore.getLocation();
            const pages = locationList.pages;
            const createLocationError = LocationStore.getCreateLocationError();
            const errors = this.state.errors;
            errors.createLocationError = createLocationError;
            if (location && location._id) {
                window.location.href = `/locations/${location._id}`;
            }
            else {
                this.setState({
                    locations,
                    totalPages: pages,
                    errors,
                });
            }
        };
        this.handlePaginationSelect = (page) => {
            this.setState((prevState) => ({
                filters: Object.assign(Object.assign({}, prevState.filters), { page }),
            }), () => {
                LocationActionCreators.getLocations(this.state.filters); // Find a way to add this to the poller component
            });
        };
        this.handleHide = () => {
            LocationStore.clearCreateLocationError();
            this.setState({
                showCreateLocationModal: false,
            }, () => {
                LocationActionCreators.getLocations(this.state.filters);
            });
        };
        this.handleCreateLocation = async (newLocation) => {
            await LocationActionCreators.createLocation(newLocation);
            this.setState({ showCreateLocationModal: false });
        };
        this.handleShowCreateLocationModal = () => this.setState({ showCreateLocationModal: true });
        this.handleConfirmDelete = () => {
            LocationActionCreators.removeLocation(this.state.currentLocation._id);
            this.handleHideConfirmModal();
        };
        this.handleDelete = (row) => {
            this.setState({
                currentLocation: row,
                showConfirmModal: true,
            });
        };
        this.handleHideConfirmModal = () => {
            this.setState({
                showConfirmModal: false,
                currentLocation: null,
            });
        };
        this.clearLocationSearch = () => {
            const { filters } = this.state;
            const clearedSearch = _.omit(filters, 'search');
            LocationActionCreators.getLocations(clearedSearch);
        };
        this.handleLocationSearch = (item) => {
            const { filters } = this.state;
            filters.search = item.address;
            LocationActionCreators.getLocations(filters);
        };
        this.state = Object.assign({ user: SessionStore.getUser(), errors: {}, locations: [], totalPages: 10, showCreateLocationModal: false, showLocationSearch: true, filters: {
                page: 1,
                per_page: 25,
                paginate: true,
                sort_by: '_id',
            } }, mapRoles());
        const { canDelete } = this.state;
        const canEdit = false;
        this.columnMappings = Mapping.columns.map((col) => {
            if (col.type === 'customActions') {
                return Object.assign(Object.assign({}, col), { formatExtraData: {
                        onDelete: this.handleDelete,
                        canDelete,
                        canEdit,
                    } });
            }
            return col;
        });
    }
    componentDidMount() {
        LocationStore.addChangeListener(this.handleLocationStoreChange);
    }
    componentWillUnmount() {
        LocationStore.removeChangeListener(this.handleLocationStoreChange);
    }
    canCreateLocations() {
        // Only location managers and admins can create locations
        return this.state.user.roles.some((r) => CAN_CREATE_LOCATIONS.includes(r));
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", { className: "p-4 bg-white rounded shadow" },
            React.createElement(DataPoller, { action: () => LocationActionCreators.getLocations(this.state.filters) }),
            React.createElement("div", { className: "flex mt-4 mb-4" },
                React.createElement("div", { className: "w-1/3" }, this.state.showLocationSearch && (React.createElement(LocationSearch, { placeholder: t('LOCATION_SEARCH'), handleLocationSearch: this.handleLocationSearch }))),
                React.createElement("div", null,
                    React.createElement("button", { className: "button button-green ml-2", onClick: this.clearLocationSearch }, titleize(t('CLEAR'))))),
            React.createElement("div", { className: "flex items-center header" },
                React.createElement("h3", { className: "mt-0 mb-0 mr-2" }, t('LOCATIONS')),
                this.canCreateLocations() && (React.createElement("button", { title: t('CREATE_LOCATION'), className: "flex items-center text-white button button-circle bg-green", onClick: this.handleShowCreateLocationModal },
                    React.createElement("i", { className: "mr-0 fa fa-plus" })))),
            React.createElement(CreateLocationModal, { onHide: this.handleHide, show: this.state.showCreateLocationModal, onCreate: this.handleCreateLocation, error: this.state.errors.createLocationError }),
            React.createElement(DataList, { striped: true, showHeaders: true, paginate: true, data: this.state.locations, columns: this.columnMappings, pages: this.state.totalPages, page: this.state.filters.page, onPaginationSelect: this.handlePaginationSelect }),
            React.createElement(ConfirmModal, { show: this.state.showConfirmModal, title: t('DELETE_CONFIRMATION'), message: t('DELETE_LOCATION_CONFIRMATION'), onConfirm: this.handleConfirmDelete, onHide: this.handleHideConfirmModal })));
    }
}
export default withTranslation()(List);
